import $ from 'cash-dom';
import { iframeResizer } from 'iframe-resizer';
export default function () {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    $('.largeiframe-mobileonly').on('click', function (e) {
      const iframe = $(this).find('iframe');
      const src = $(iframe).data('src');
      $(this).addClass('loading');
      $(iframe).attr('src', src);
    });
  } else {
    $('.largeiframe-mobileonly').each(function (e) {
      const iframe = $(this).find('iframe');
      const src = $(iframe).data('src');
      $(this).addClass('loading');
      $(iframe).attr('src', src);
    });
  }
  $('.largeiframe').on('click', function (e) {
    const iframe = $(this).find('iframe');
    const src = $(iframe).data('src');
    $(this).addClass('loading');
    $(iframe).attr('src', src);
  });
  iframeResizer({}, '.iframe-resize');
}